import React, { useState, useEffect } from 'react';
import { Search, Ban, CheckCircle, User, Trash2 } from 'lucide-react';
import { usersAPI } from '../../services/api';

const ManageFans = () => {
  const [fans, setFans] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => { fetchFans(); }, []);

  const fetchFans = async () => {
    try { const res = await usersAPI.getAll(); setFans(res.data.filter(u => u.role === 'fan')); }
    catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  const handleToggleBlock = async (fan) => {
    try {
      await usersAPI.update(fan.id, { name: fan.name, email: fan.email, phone: fan.phone, is_blocked: !fan.is_blocked });
      fetchFans();
    } catch (e) { alert('Error updating fan'); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this fan account?')) return;
    try { await usersAPI.delete(id); fetchFans(); }
    catch (e) { alert('Error deleting fan'); }
  };

  const filtered = fans.filter(f =>
    f.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    f.email.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="min-h-screen pt-20 pb-12">
      <section className="bg-gradient-to-r from-primary to-surface-dark py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl font-heading font-bold text-white">Manage <span className="text-accent">Fans</span></h1>
          <p className="text-gray-400 mt-2">View and manage registered fan accounts</p>
        </div>
      </section>

      <section className="py-8 bg-surface">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-8 max-w-md">
            <div className="relative">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-500" />
              <input type="text" placeholder="Search fans..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} className="input-field pl-10" />
            </div>
          </div>

          {loading ? (
            <div className="flex justify-center py-12"><div className="animate-spin rounded-full h-12 w-12 border-t-4 border-primary"></div></div>
          ) : (
            <div className="card overflow-hidden">
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead className="bg-surface-light">
                    <tr>
                      <th className="px-6 py-4 text-left text-gray-400 font-medium">Fan</th>
                      <th className="px-6 py-4 text-left text-gray-400 font-medium">Email</th>
                      <th className="px-6 py-4 text-left text-gray-400 font-medium">Phone</th>
                      <th className="px-6 py-4 text-left text-gray-400 font-medium">Joined</th>
                      <th className="px-6 py-4 text-center text-gray-400 font-medium">Status</th>
                      <th className="px-6 py-4 text-center text-gray-400 font-medium">Actions</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-800">
                    {filtered.map((fan) => (
                      <tr key={fan.id} className="hover:bg-surface-light transition-colors">
                        <td className="px-6 py-4">
                          <div className="flex items-center">
                            <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center mr-3">
                              <User className="w-5 h-5 text-white" />
                            </div>
                            <span className="text-white font-medium">{fan.name}</span>
                          </div>
                        </td>
                        <td className="px-6 py-4 text-gray-400">{fan.email}</td>
                        <td className="px-6 py-4 text-gray-400">{fan.phone || '-'}</td>
                        <td className="px-6 py-4 text-gray-400">{new Date(fan.created_at).toLocaleDateString()}</td>
                        <td className="px-6 py-4 text-center">
                          <span className={`px-2 py-1 text-xs rounded-full ${fan.is_blocked ? 'bg-red-500/20 text-red-400' : 'bg-green-500/20 text-green-400'}`}>
                            {fan.is_blocked ? 'blocked' : 'active'}
                          </span>
                        </td>
                        <td className="px-6 py-4 text-center">
                          <button onClick={() => handleToggleBlock(fan)} className={`p-2 rounded-lg mr-2 transition-colors ${fan.is_blocked ? 'text-green-500 hover:bg-green-500/10' : 'text-red-500 hover:bg-red-500/10'}`}>
                            {fan.is_blocked ? <CheckCircle className="w-5 h-5" /> : <Ban className="w-5 h-5" />}
                          </button>
                          <button onClick={() => handleDelete(fan.id)} className="p-2 text-red-500 hover:bg-red-500/10 rounded-lg">
                            <Trash2 className="w-5 h-5" />
                          </button>
                        </td>
                      </tr>
                    ))}
                    {filtered.length === 0 && <tr><td colSpan="6" className="px-6 py-12 text-center text-gray-500">No fans found</td></tr>}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default ManageFans;
